import Cookie from 'js-cookie';

const getCookie = (name) => Cookie.get(name);

export default getCookie;
